import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBillLading } from "src/models/Products/BillLading.models";

interface BillLadingState {
  billLadings: IBillLading[];
  billLadingToEdit: IBillLading | null;
}

const initialState: BillLadingState = {
  billLadings: [],
  billLadingToEdit: null,
};

const memberClubSchemeSlice = createSlice({
  name: "BillLading",
  initialState,
  reducers: {
    setBillLadingList: (
      state,
      action: PayloadAction<IBillLading[]>
    ) => {
      state.billLadings = action.payload;
    },
    concatListBillLading: (
      state: BillLadingState,
      action: PayloadAction<IBillLading[]>
    ) => {
      state.billLadings = [
        ...state.billLadings.concat(action.payload),
      ];
    },
    setBillLadingToEdit: (
      state,
      action: PayloadAction<IBillLading | null>
    ) => {
      state.billLadingToEdit = action.payload;
    },
    addBillLading: (state, action: PayloadAction<IBillLading>) => {
      state.billLadings.push(action.payload);
    },
    updateBillLading: (
      state,
      action: PayloadAction<IBillLading>
    ) => {
      let itemIndex = state.billLadings.findIndex(
        item => item.billLadingId === action.payload.billLadingId
      );
      if (itemIndex !== -1) state.billLadings[itemIndex] = action.payload;
    },
    deleteBillLading: (state, action: PayloadAction<number>) => {
      const newArray = state.billLadings.filter(
        item => item.billLadingId !== action.payload
      );
      state.billLadings = newArray;
    },
  },
});

export const {
  setBillLadingList,
  concatListBillLading,
  setBillLadingToEdit,
  addBillLading,
  updateBillLading,
  deleteBillLading,
} = memberClubSchemeSlice.actions;

export default memberClubSchemeSlice.reducer;
